<template>
    <footer>
    </footer>
</template>
<script>
export default {
    name: 'FirmatechFooter',
}
</script>